import React, { useRef, useState } from "react";
import { Button, Modal, Toast } from '@themesberg/react-bootstrap';
import { AddNotificationForm } from "./partials/AddNotificationForm";
import { useCookies } from "react-cookie";
import { addNewToAll, addNewToUser } from "../../../../../controller/api/notification";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [error, setError] = useState(false)

  const userRef = useRef(null)

  const titleRef = useRef('')

  const messageRef = useRef('')

  const isGetAllRef = useRef(true)

  const onMessageChange = (text) => {
    messageRef.current = text
  }

  const onTitleChange = (text) => {
    titleRef.current = text
  }

  const onUserSelect = (user) => {
    userRef.current = user
  }

  const onIsGetAllSelect = (isGetAll) => {
    isGetAllRef.current = isGetAll === 1
  }

  const validateAddNotification = () => {
    let status = true
    if (!isGetAllRef.current) {
      if (!userRef.current) {
        status = false
      }
    }

    if (messageRef.current.trim().length > 0 && titleRef.current.trim().length > 0) {
      return status && true
    }
    return false
  }

  const onSubmit = async () => {
    try {
      if (validateAddNotification()) {
        if (isGetAllRef.current) {
          const resp = await addNewToAll(cookies.lottmekong, titleRef.current, messageRef.current)
          if (resp) {
            window.location.reload()
          } else {
            alert('Có lỗi xảy ra')
            return false
          }
        } else {
          const resp = await addNewToUser(cookies.lottmekong, titleRef.current, messageRef.current, userRef.current.phone, userRef.current.id)
          if (resp) {
            window.location.reload()
          } else {
            alert('Có lỗi xảy ra')
            return false
          }
        }
      } else {
        setError(true)
      }
    } catch (e) {
      alert('error')
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm thông báo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Toast className="d-inline-block m-1" onClose={() => setError(false)} show={error} delay={3000} autohide bg='danger' key={3} >
          <Toast.Header>
            <strong className="me-auto">Lỗi</strong>
            {/* <small>11 mins ago</small> */}
          </Toast.Header>
          <Toast.Body>Không thêm được</Toast.Body>
        </Toast>
        <AddNotificationForm
          setTitle={onTitleChange}
          setMessage={onMessageChange}
          setIsGetAll={onIsGetAllSelect}
          setDetectedUser={onUserSelect}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit}>Thêm</Button>
      </Modal.Footer>
    </Modal>
  );
}
